import * as Yup from 'yup'
import SignupFormModel from './SignupFormModel'

const {
  formField: {
    firstName,
    lastName,
    email,
    password,
    profileType,
    country,
    postalCode,
    photo,
    heroImage,
    about,
    title,
    employmentStatus,
    step,
  },
} = SignupFormModel

export const AccountValidations = Yup.object().shape({
  [firstName.name]: Yup.string().required(`${firstName.requiredErrorMsg}`),
  [lastName.name]: Yup.string().required(`${lastName.requiredErrorMsg}`),
  [email.name]: Yup.string().required(`${email.requiredErrorMsg}`),
  [password.name]: Yup.string().required(`${password.requiredErrorMsg}`),
})

export const UserValidations = Yup.object().shape({
  [email.name]: Yup.string().required(`${email.requiredErrorMsg}`),
  [password.name]: Yup.string().required(`${password.requiredErrorMsg}`),
})

const shape = [
  Yup.object().shape({
    [profileType.name]: Yup.string().required(`${profileType.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    [country.name]: Yup.string().required(`${country.requiredErrorMsg}`),
    [postalCode.name]: Yup.string().required(`${postalCode.requiredErrorMsg}`),
  }),
  Yup.object().shape({
    [photo.name]: Yup.string(),
  }),
  Yup.object().shape({
    [heroImage.name]: Yup.string(),
  }),
  Yup.object().shape({
    [about.name]: Yup.string(),
    [title.name]: Yup.string(),
    [employmentStatus.name]: Yup.string(),
  }),
]

export default shape
